import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { CreditCardComponent } from './credit-card.component';
import { NgxStripeModule } from 'ngx-stripe';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@NgModule({
  declarations: [CreditCardComponent],
  providers: [],
  imports: [
    CommonModule,
    NzInputModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzSpinModule,
    NgxStripeModule.forRoot()
  ],
  exports: [CreditCardComponent]
})
export class CreditCardModule {}
